import { G } from "./theme";

export function calcScore(respostas, pilar) {
  var total = 0, max = 0;
  for (var i = 0; i < pilar.perguntas.length; i++) {
    var v = (respostas[pilar.key] && respostas[pilar.key][i]) || 0;
    total += v * pilar.perguntas[i].p; max += 5 * pilar.perguntas[i].p;
  }
  return Math.round((total / max) * 100) / 10;
}

export function getMedia(scores) {
  var v = Object.values(scores), s = 0;
  for (var i = 0; i < v.length; i++) s += v[i];
  return Math.round(s / v.length * 10) / 10;
}

export function getCl(m) {
  if (m >= 8.5) return { label:"Ótimo", cor:"#4CAF50", bg:"#4CAF5022" };
  if (m >= 7)   return { label:"Bom", cor:G, bg:G+"22" };
  if (m >= 5)   return { label:"Moderado", cor:"#FF9800", bg:"#FF980022" };
  if (m >= 3)   return { label:"Em Risco", cor:"#FF5722", bg:"#FF572222" };
  return { label:"Crítico", cor:"#E53935", bg:"#E5393522" };
}

export function genToken() { return Math.random().toString(36).slice(2,10).toUpperCase(); }

export function initials(n) { return n.split(" ").map(function(p){ return p[0]; }).join("").slice(0,2).toUpperCase(); }
